module.exports = __webpack_public_path__ + "static/media/pasta_1000.070e829e.png";